var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6527 12.0467V7.29085C22.6527 6.40251 21.981 5.39501 21.1468 5.05918L15.1127 2.58918C13.7585 2.03668 12.231 2.03668 10.8768 2.58918L4.84266 5.05918C4.01932 5.39501 3.34766 6.40251 3.34766 7.29085V12.0467C3.34766 17.3442 7.19349 22.3058 12.4477 23.7575C12.8052 23.855 13.1952 23.855 13.5527 23.7575C18.8068 22.3058 22.6527 17.3442 22.6527 12.0467ZM13.8127 13.9425V16.7917C13.8127 17.2358 13.4443 17.6042 13.0002 17.6042C12.556 17.6042 12.1877 17.2358 12.1877 16.7917V13.9425C11.0935 13.5958 10.2918 12.5775 10.2918 11.375C10.2918 9.88001 11.5052 8.66668 13.0002 8.66668C14.4952 8.66668 15.7085 9.88001 15.7085 11.375C15.7085 12.5883 14.9068 13.5958 13.8127 13.9425Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.2e12734b83bd2510ff2680176d21fb47.svg";
export { ForwardRef as ReactComponent };